import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { CommonFunctionService } from './../Common/common-function.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VposUserAppView } from 'src/app/models/vpos-user-app-view';
import { PosUserResponse } from 'src/app/models/pos-user-response';
@Injectable()
export class LoginService {
  token: any;
  headers: any;
  constructor(private service: AuthService, private http: HttpClient, private commonfunction: CommonFunctionService) { }

  loginUser(data) {
    return this.service.login(data);
  }

  logout() {
    localStorage.removeItem('VirtualPOSToken');
  }

  virtualTerminalAccess(data) {
    return this.service.loginSupportUser(data);
  }

  GetUserDetails(email, userType) {
    this.GetUserAuthdetails();
    return this.http.get<VposUserAppView>(environment.checkMMSUserdetailsUrl + '?email=' + email +
      "&userType=" + userType, { headers: this.headers });
  }
  resendMobileOTP(contactNo, userType) {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.resendMobileOTPUrl + "?contactNo=" + contactNo + '&userType=' + userType, { headers: this.headers })
  }
  resendEmailOTP(email, userType) {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.resendEmailOTPUrl + "?email=" + email + '&userType=' + userType, { headers: this.headers })
  }
  getresellerdatabasedonurl(url) {
    this.GetUserAuthdetails();
    return this.http.get<any>(environment.getresellerdatabasedonurl + "?url=" + url, { headers: this.headers });
  }
  getresellerlogo(resellerid) {

    this.GetUserAuthdetails();
    return this.http.get<any>(environment.getresellerlogoUrl + "?resellerid=" + resellerid, { headers: this.headers });
  }
  SessionToken(data) {
    return this.http.post<any>(environment.saveSessionToken, data);
  }

  GetUserAuthdetails() {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" + 'IT';
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
}

